import { Typography } from '@mui/material';

import { useUpdatePiecesMutation } from '@api/piece';
import { PieceAction } from '@apiContract';

import { DialogConfirmation } from '@uiKit/DialogConfirmation';

import { ActionComponentProps } from '../../index';

export const FinishDelivery = ({ mailpieces, actionStarted, onActionFinish }: ActionComponentProps) => {
  const [updatePieces, { isLoading }] = useUpdatePiecesMutation();

  const confirmAction = async () => {
    await updatePieces({
      pieces: mailpieces.map((piece) => ({ id: piece.id })),
      action: PieceAction.FinishDelivery,
    }).unwrap();

    onActionFinish();
  };

  return (
    <DialogConfirmation
      open={actionStarted}
      loading={isLoading}
      maxWidth="xs"
      title={mailpieces.length === 1 ? 'Deliver item' : 'Deliver selected items'}
      content={
        <Typography variant="body1" color="text.secondary">
          {mailpieces.length === 1 ? (
            <>
              Please deliver this item to{' '}
              <strong>{mailpieces[0].recipient ? mailpieces[0].recipient.displayName : 'recipient'}</strong>, and click
              Complete when you’re done.
            </>
          ) : (
            <>
              Please deliver <strong>{mailpieces.length}</strong> items to{' '}
              <strong>{mailpieces[0].recipient ? mailpieces[0].recipient.displayName : 'recipient'}</strong>, and click
              Complete when you’re done.
            </>
          )}
        </Typography>
      }
      acceptButtonHandleClick={confirmAction}
      cancelButtonHandleClick={onActionFinish}
      acceptButtonTitle="Complete"
      cancelButtonTitle="Cancel"
    />
  );
};
